import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import ErsTopBar from './ErsTopBar'
import { Grid, Table, TableHead, TableBody, TableRow, TableCell, Checkbox } from '@material-ui/core'
import { Button } from '@michelin/acid-components'
import AddIcon from '@material-ui/icons/Add'
import MaterialInputable from './MaterialInputable'
import InboundPhone from './InboundPhone'
import NewDialog from './inbound/NewDialog'

const styles = theme => ({
	formControl: {
		marginLeft: theme.spacing.unit,
		marginRight: theme.spacing.unit,
	},
	button: {
		margin: theme.spacing.unit,
	},
	textField: {
		marginLeft: 0,
		marginRight: 0,
	},
	stickyGrid: {
		position: "sticky",
		paddingLeft: theme.spacing(2),
		paddingRight: theme.spacing(2),
		zIndex: "10",
		backgroundColor: '#FFFFFF',
		top: 81,
		height: 64,
	},
	tableCell: {
		textDecoration: 'none'
	},
	noLines: {
		border: 0,
		borderStyle: "hidden"
	},
	tableContainer: {
		marginTop: 84,
	},
	tableHead: {
		fontWeight: 'bold',
		padding: theme.spacing(1),
		lineHeight: 'inherit',
		backgroundColor: 'rgba(0, 0, 0, .04)'
	},
	dialog: {
		height: 800
	},
	marginLeft: {
		marginLeft: 15
	},
	paddingMe: {
		marginLeft: '20px'
	},
	paper: {
		width: '99%',
	}
})

class InboundProgram extends React.Component {
	constructor(props) {
		super(props)

		const states = [
			{ name: 'Alabama', short: 'Ala', id: 'AL', country: 'USA' },
			{ name: 'Alaska', short: 'Alaska', id: 'AK', country: 'USA' },
			{ name: 'Arizona', short: 'Ariz.', id: 'AZ', country: 'USA' },
			{ name: 'Arkansas', short: 'Ark.', id: 'AR', country: 'USA' },
			{ name: 'California', short: 'Calif.', id: 'CA', country: 'USA' },
			{ name: 'Colorado', short: 'Colo.', id: 'CO', country: 'USA' },
			{ name: 'Connecticut', short: 'Conn.', id: 'CT', country: 'USA' },
			{ name: 'Delaware', short: 'Del.', id: 'DE', country: 'USA' },
			{ name: 'Dist.of Columbia', short: 'D.C.', id: 'DC', country: 'USA' },
			{ name: 'Florida', short: 'Fla.', id: 'FL', country: 'USA' },
			{ name: 'Georgia', short: 'Ga.', id: 'GA', country: 'USA' },
			{ name: 'Hawaii', short: 'Hawaii', id: 'HI', country: 'USA' },
			{ name: 'Idaho', short: 'Idaho', id: 'ID', country: 'USA' },
			{ name: 'Illinois', short: 'Ill.', id: 'IL', country: 'USA' },
			{ name: 'Indiana', short: 'Ind.', id: 'IN', country: 'USA' },
			{ name: 'Iowa', short: 'Iowa', id: 'IA', country: 'USA' },
			{ name: 'Kansas', short: 'Kans.', id: 'KS', country: 'USA' },
			{ name: 'Kentucky', short: 'Ky.', id: 'KY', country: 'USA' },
			{ name: 'Louisiana', short: 'La.', id: 'LA', country: 'USA' },
			{ name: 'Maryland', short: 'MD', id: 'MD', country: 'USA' },
			{ name: 'Maine', short: 'Maine', id: 'ME', country: 'USA' },
			{ name: 'Massachusetts', short: 'Mass.', id: 'MA', country: 'USA' },
			{ name: 'Michigan', short: 'Mich.', id: 'MI', country: 'USA' },
			{ name: 'Minnesota', short: 'Minn.', id: 'MN', country: 'USA' },
			{ name: 'Mississippi', short: 'Miss.', id: 'MS', country: 'USA' },
			{ name: 'Missouri', short: 'Mo.', id: 'MO', country: 'USA' },
			{ name: 'Montana', short: 'Mont.', id: 'MT', country: 'USA' },
			{ name: 'Nebraska', short: 'Nebr.', id: 'NE', country: 'USA' },
			{ name: 'Nevada', short: 'Nev.', id: 'NV', country: 'USA' },
			{ name: 'New Hampshire', short: 'N.H.', id: 'NH', country: 'USA' },
			{ name: 'New Jersey', short: 'N.J.', id: 'NJ', country: 'USA' },
			{ name: 'New Mexico', short: 'N.M.', id: 'NM', country: 'USA' },
			{ name: 'New York', short: 'N.Y.', id: 'NY', country: 'USA' },
			{ name: 'North Carolina', short: 'N.C.', id: 'NC', country: 'USA' },
			{ name: 'North Dakota', short: 'N.D.', id: 'ND', country: 'USA' },
			{ name: 'Ohio', short: 'Ohio', id: 'OH', country: 'USA' },
			{ name: 'Oklahoma', short: 'Okla.', id: 'OK', country: 'USA' },
			{ name: 'Oregon', short: 'Ore.', id: 'OR', country: 'USA' },
			{ name: 'Pennsylvania', short: 'Pa.', id: 'PA', country: 'USA' },
			{ name: 'Rhode Island', short: 'R.I.', id: 'RI', country: 'USA' },
			{ name: 'South Carolina', short: 'S.C.', id: 'SC', country: 'USA' },
			{ name: 'South Dakota', short: 'S.D.', id: 'SD', country: 'USA' },
			{ name: 'Tennessee', short: 'Tenn.', id: 'TN', country: 'USA' },
			{ name: 'Texas', short: 'Tex.', id: 'TX', country: 'USA' },
			{ name: 'Utah', short: 'Utah', id: 'UT', country: 'USA' },
			{ name: 'Vermont', short: 'Vt.', id: 'VT', country: 'USA' },
			{ name: 'Virginia', short: 'Va.', id: 'VA', country: 'USA' },
			{ name: 'Washington', short: 'Wash.', id: 'WA', country: 'USA' },
			{ name: 'West Virginia', short: 'W.Va.', id: 'WV', country: 'USA' },
			{ name: 'Wisconsin', short: 'Wis.', id: 'WI', country: 'USA' },
			{ name: 'Wyoming', short: 'Wyo.', id: 'WY', country: 'USA' },

			{ name: 'Alberta', short: 'AB', id: 'AB', country: 'CAN' },
			{ name: 'British Columbia', short: 'BC', id: 'BC', country: 'CAN' },
			{ name: 'Manitoba', short: 'MB', id: 'MB', country: 'CAN' },
			{ name: 'New Brunswick', short: 'NB', id: 'NB', country: 'CAN' },
			{ name: 'Newfoundland', short: 'NL', id: 'NL', country: 'CAN' },
			{ name: 'Northwest Territories', short: 'NT', id: 'NT', country: 'CAN' },
			{ name: 'Nunavut', short: 'NU', id: 'NU', country: 'CAN' },
			{ name: 'Ontario', short: 'ON', id: 'ON', country: 'CAN' },
			{ name: 'Price Edward Island', short: 'PE', id: 'PE', country: 'CAN' },
			{ name: 'Quebec', short: 'QC', id: 'QC', country: 'CAN' },
			{ name: 'Saskatchewan', short: 'SK', id: 'SK', country: 'CAN' },
			{ name: 'Yukon', short: 'YT', id: 'YT', country: 'CAN' },
		]

		this.state = {
			searchText: "",
			saving: false,
			states: states, 
		}
		this.searchChange = this.searchChange.bind(this)
	}

	search(event) {
	}

	searchChange(event) {
		this.setState({ searchText: event.target.value })
	} 

	render() {
		const { isEagleSupervisor, classes, openEdit, editCloseMe, loadedProgram, inboundProgramNumbers, closeMe, openEditInbound, addInbound, fetchNumbers, inboundProgramAccountTypes, open, assetValidationTypes, vehicleTypes } = this.props

		let searchText = this.state.searchText
		let samster
		if (openEdit) {
			samster = <NewDialog open={openEdit} vehicleTypes={vehicleTypes} assetValidationTypes={assetValidationTypes} isEagleSupervisor={isEagleSupervisor} isEdit={true} loadedProgram={loadedProgram} inboundProgramAccountTypes={inboundProgramAccountTypes} closeMe={editCloseMe} fetchNumbers={fetchNumbers} />
		} 
		return (
			<React.Fragment>
				<ErsTopBar />

				<Grid container spacing={1} className={classes.stickyGrid}>
					<Grid item xs={6} sm={4} md={3} lg={2}>
						<MaterialInputable
							name={"inboundSearch"}
							label="Search"
							value={this.state.searchText}
							onChange={this.searchChange} />
					</Grid>
					<Grid item xs={6} sm={4} md={3} lg={2} style={{ alignSelf: 'center' }}>
						<Button color="primary" aria-label="Add new program" className={classes.button}
							onClick={addInbound} disabled={!isEagleSupervisor}>
							<AddIcon className={classes.extendedIcon} />
							Add New Program
						</Button>
					</Grid>
				</Grid>
				<Grid container spacing={1} className={classes.tableContainer}>
					<Grid item lg={12}>
						<Table className={classes.table} size="small">
							<TableHead>
								<TableRow >
									<TableCell className={classes.tableHead}>Customer Name</TableCell>
									<TableCell className={classes.tableHead}>Toll Free Number</TableCell>
									<TableCell className={classes.tableHead}>Account Type</TableCell>
									<TableCell className={classes.tableHead}>BT Number</TableCell>
									<TableCell className={classes.tableHead}>ST Number</TableCell>
									<TableCell className={classes.tableHead}>Exclude Auto Close</TableCell>
									<TableCell className={classes.tableHead}>Electronic Service Dispatch</TableCell>
									<TableCell className={classes.tableHead}>Disabled</TableCell>
								</TableRow>
							</TableHead>
							<TableBody className={classes.tableBody}>
								{inboundProgramNumbers && inboundProgramNumbers.filter(inbound => {
									if (searchText) {
										return (inbound.customerName && inbound.customerName.toLowerCase().includes(searchText.toLowerCase())) ||
											(inbound.tollFreeNumber && inbound.tollFreeNumber.toLowerCase().includes(searchText.toLowerCase())) ||
											(inbound.billTo && inbound.billTo.toLowerCase().includes(searchText.toLowerCase())) ||
											(inbound.shipTo && inbound.shipTo.toLowerCase().includes(searchText.toLowerCase())) ||
											(inbound.type && inbound.type.name && inbound.type.name.toLowerCase().includes(searchText.toLowerCase()))
									} else {
										return true
									}
								}).sort((a, b) => { return a.customerName.localeCompare(b.customerName) }).map(row => {
									return (
										<TableRow className={classes.noLines} hover key={row.id} onClick={event => openEditInbound(Object.assign({}, row))}>
											<TableCell className={classes.tableCell}>{row.customerName}</TableCell>
											<TableCell className={classes.tableCell}> <InboundPhone value={row.tollFreeNumber} name="phone" disabled /></TableCell>
											<TableCell className={classes.tableCell}>{row.type.name}</TableCell>
											<TableCell className={classes.tableCell}>{row.billTo}</TableCell>
											<TableCell className={classes.tableCell}>{row.shipTo}</TableCell>
											<TableCell className={classes.tableCell}><Checkbox color="primary" checked={row.excludeAutoClose} /></TableCell>
											<TableCell className={classes.tableCell}><Checkbox color="primary" checked={row.isEsd} /></TableCell>
											<TableCell className={classes.tableCell}><Checkbox color="primary" checked={row.isDisabled} /></TableCell>
										</TableRow>
									)
								})}
							</TableBody>
						</Table>
					</Grid>
				</Grid>

				<NewDialog open={open} isEagleSupervisor={isEagleSupervisor} vehicleTypes={vehicleTypes} assetValidationTypes={assetValidationTypes} inboundProgramAccountTypes={inboundProgramAccountTypes} closeMe={closeMe} fetchNumbers={fetchNumbers} />
				{ openEdit && samster}
			</React.Fragment>
		)
	}
}

InboundProgram.propTypes = {
	classes: PropTypes.object,
	inboundProgramNumbers: PropTypes.array,
	saveNewInbound: PropTypes.func,
	openEditInbound: PropTypes.func,
	fetchNumbers: PropTypes.func,
	newInboundProgram: PropTypes.object,
	newOnChange: PropTypes.func,
	inboundProgramAccountTypes: PropTypes.array,
	newSelectOnChange: PropTypes.func,
	addInbound: PropTypes.func,
	open: PropTypes.bool,
	startingInboundSave: PropTypes.func,
	isSaving: PropTypes.bool,
	closeEditInbound: PropTypes.func,
	loadedProgram: PropTypes.object,
	editSelectOnChange: PropTypes.func,
	editOnChange: PropTypes.func,
	saveInboundEdit: PropTypes.func,
	nameSearch: PropTypes.bool,
	potentialCustomers: PropTypes.object,
	loadCustomer: PropTypes.func,
	newOnChangeCustomerName: PropTypes.func,
	closeMe: PropTypes.func,
	openEdit: PropTypes.bool,
	editCloseMe: PropTypes.func
}

export default withStyles(styles)(InboundProgram)


// WEBPACK FOOTER //
// ./src/components/InboundProgram.js